define('page/home', ['ISwiper', 'utils/dom', 'Swiper', 'utils/AnimateProcessor', 'imgZoom', 'utils/common'], function (ISwiper, dom, Swiper, AnimateProcessor, imgZoom, common) {

    /**
     * 头部banner esm
     */
    var bannerSwiper = new ISwiper.default({
        wrapper: '#homeBanner',
        duration: 5000,
        btn: {
            visible: false,
            transition: false
        },
        mode: 'fade',
    })



    /**
     * 全能小未
     */
    var allroundSwiper = new ISwiper.default({
        wrapper: '#allaroud',
        duration: 0,
        btn: {
            visible: false,
            transition: false
        },
        mode: 'fade',
        openNav: false,
    })

    // 这部分对全能小未交互
    var allList = document.querySelector('.home-allaroud .content .list')
    var allListTabs = allList.querySelectorAll('.tab')

    if (allListTabs.length) {
        var currTabsIndex = allroundSwiper.currIndex
        dom.addClass(allListTabs[currTabsIndex], 'theme-color')

        allList.addEventListener('mouseover', function (e) {
            var target = e.target
            var i
            if ((i = dom.getData(target, 'index')) !== null && (i = parseFloat(i)) < allroundSwiper.count) {
                dom.removeElsClass(allListTabs, 'theme-color')
                dom.addClass(target, 'theme-color')
                allroundSwiper.goToPage(i)
            }
        })

        var $containerStyle = allroundSwiper.$container.style

        imgZoom("#amplierWrap", "amplier").init({
            bgColor: "rgba(0, 0, 0, .4)",
            transitionDuration: ".35s",
            transitionTimingFunction: "cubic-bezier(.4,0,0,1)",
            scale: 1.8,
            onBeforeOpen: function () {
                $containerStyle.overflow = 'visible'
            },
            onClose: function () {
                $containerStyle.overflow = ''
            }
        });
    }

    /**
     * 小未案例
     */

    var caseList = document.querySelector('#caseList')

    if (caseList) {
        var caseLabels = Array.prototype.slice.call(caseList.children)
        // 移除更多
        caseLabels.pop()

        function toggleCaseLabel(index) {
            dom.removeElsClass(caseLabels, 'active')
            dom.addClass(caseLabels[index], 'active')
        }

        var anliSwiper = new Swiper('#anliSwiper', {
            autoplay: false,
            speed: 1000,
            loop: true,
            centeredSlides: true,
            slidesPerView: 3,
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            on: {
                transitionStart: function () {
                    var curIndex = this.realIndex;
                    toggleCaseLabel(curIndex);
                }
            }
        })

        caseList.addEventListener('click', function (e) {
            var target = e.target
            var i
            if ((i = dom.getData(target, 'label-index'))) {
                i = parseFloat(i)
                toggleCaseLabel(i)
                anliSwiper.slideToLoop(i, 1000, false)
            }
        })
    }




    /**
     * 头部动画计数器imp
     */
    var countEls = document.querySelectorAll('.animate-count')
    if (countEls.length > 0) {
        countEls = Array.prototype.slice.call(countEls)
        var counts = countEls.map(function (el) {
            return parseFloat(dom.getData(el, 'count'))
        })
        var aProcessor = new AnimateProcessor()
        aProcessor.excuteAnimaFrame(function (percentage) {
            var i = counts.length
            var currEl, currCount
            while (i--) {
                currEl = countEls[i]
                currCount = counts[i]
                currEl.innerText = (currCount * this.getIncByTimeFn('ease-in-out', percentage)).toFixed(0) + '+'
            }
            return percentage < 1
        })
    }


    /**
     * 新闻咨询交互
     */
    var newsTabs = document.querySelector('#newsTabs')
    var newsListBox = document.querySelector('#newsListBox')
    var eventListBox = document.querySelector('#eventListBox')

    if (newsTabs && newsListBox && eventListBox) {
        var children = newsTabs.children
        var newsListBoxStyle = newsListBox.style
        var eventListBoxStyle = eventListBox.style

        if (children.length > 0) {
            newsTabs.addEventListener('click', function (e) {
                var target = e.target
                var i = dom.getData(target, 'index')
                if (i) {
                    i = parseFloat(i)
                    dom.removeElsClass(children, 'active')
                    dom.addClass(children[i], 'active')
                    if (i === 0) {
                        newsListBoxStyle.display = 'block'
                        eventListBoxStyle.display = 'none'
                    } else {
                        newsListBoxStyle.display = 'none'
                        eventListBoxStyle.display = 'block'
                    }
                }
            })
        }
    }


    /**
     * 提交加入小未表单
     */
    var nameEl = document.querySelector('#homeName')
    var phoneEl = document.querySelector('#homePhone')
    var btnEL = document.querySelector('#homeJoin')

    if (nameEl && phoneEl && btnEL) {
        btnEL.addEventListener('click', function () {
            common.submitForm([nameEl, phoneEl])
        })
    }
});
